import Transition from '@ember/routing/-private/transition';
import Route from 'cio/routes/base';
import StripeV3Service from 'ember-stripe-elements/services/stripev3';
import { inject as service } from '@ember/service';
import { redirectToSettingsIfNoPermission } from 'cio/utils/route-access';

export default class PaymentMethodsRoute extends Route {
  @service('stripev3') stripe!: StripeV3Service;

  crumb() {
    return {
      name: 'Payment Methods',
      path: this.routeName,
      helpQuery: 'payment methods',
    };
  }

  async beforeModel(transition: Transition) {
    await super.beforeModel(transition);
    redirectToSettingsIfNoPermission(this, 'account/billing/view', transition);
    return this.stripe.load();
  }
}
